<!-- Desktop Version -->
<div
    class="tw-hidden lg:tw-flex tw-flex-col tw-gap-[30px] tw-px-[140px] lg:tw-py-[50px] md:tw-py-[30px] tw-items-center"
>
    <div
        class="tw-flex tw-flex-col tw-gap-[18px] tw-items-start md:tw-items-center"
    >
        <span
            class="lg:tw-text-[28px] md:tw-text-[20px] tw-text-[22px] tw-font-bold tw-text-[#024B3F]"
            >{{ gsData?.title }}</span
        >
        <span
            [innerHTML]="gsData?.description"
            class="tw-text-[14px] tw-font-normal tw-text-center tw-leading-[22px] md:tw-max-w-[748px] default-html"
        ></span>
        <!-- <span
            class="tw-text-[14px] tw-font-normal tw-text-center tw-leading-[22px]"
            >It contains suggested actions that SMEs could take to:</span
        > -->
    </div>
    <div class="tw-flex tw-flex-col tw-gap-[20px]">
        <!-- Row 1 -->
        <div class="tw-grid tw-grid-cols-2 tw-gap-[20px] tw-items-stretch">
            <div
                *ngFor="let item of getStartedItems"
                class="tw-flex tw-flex-row tw-gap-[10px] tw-items-start tw-p-[30px] tw-bg-[#ECF0F0] tw-rounded-[10px] tw-h-full"
            >
                <img
                    [src]="item.image"
                    alt="About SMEs and GDP Image"
                    class="tw-w-[76px] tw-h-[76px] tw-p-[11px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[13px] tw-items-start tw-flex-1"
                >
                    <span
                        class="tw-text-[16px] tw-font-bold tw-leading-[22px] tw-text-left"
                        >{{ item?.title }}</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-left default-html"
                        [innerHTML]="item?.description"
                    ></span>
                </div>
            </div>
        </div>
        <!-- <div class="tw-grid tw-grid-cols-2 tw-gap-[20px] tw-items-stretch">
            <div
                class="tw-flex tw-flex-row tw-gap-[10px] tw-items-start tw-p-[30px] tw-bg-[#ECF0F0] tw-rounded-[10px] tw-h-full"
            >
                <img
                    src="assets/images/Jc3/Jc-intro-block-4-img-1.png"
                    alt="About SMEs and GDP Image"
                    class="tw-w-[76px] tw-h-[76px] tw-p-[11px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[13px] tw-items-start tw-flex-1"
                >
                    <span
                        class="tw-text-[16px] tw-font-bold tw-leading-[22px] tw-text-left"
                        >About SMEs and GDP</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-left"
                        >Small and medium enterprises ("SMEs") form the backbone
                        of Malaysia's economy, accounting for 97.2% of total
                        business establishments, generating 38.2% of GDP and
                        providing employment for 7.3 million people (OECD,
                        2022).</span
                    >
                </div>
            </div>
            <div
                class="tw-flex tw-flex-row tw-gap-[10px] tw-items-start tw-p-[30px] tw-bg-[#ECF0F0] tw-rounded-[10px] tw-h-full"
            >
                <img
                    src="assets/images/Jc3/Jc-intro-block-4-img-4.png"
                    alt="Climate Change Impact Image"
                    class="tw-w-[76px] tw-h-[76px] tw-p-[3px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[13px] tw-items-start tw-flex-1"
                >
                    <span
                        class="tw-text-[16px] tw-font-bold tw-leading-[22px] tw-text-left"
                        >Climate Change Impact</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-left"
                        >With climate change making a profound impact to the
                        planet, people and profit, more businesses, including
                        SMEs are now being subjected to ESG requirements imposed
                        by customers, lenders, investors, local communities and
                        regulators alike.</span
                    >
                </div>
            </div>
        </div> -->

        <!-- Row 2 -->
        <!-- <div class="tw-grid tw-grid-cols-2 tw-gap-[20px] tw-items-stretch">
            <div
                class="tw-flex tw-flex-row tw-gap-[10px] tw-items-start tw-p-[30px] tw-bg-[#ECF0F0] tw-rounded-[10px] tw-h-full"
            >
                <img
                    src="assets/images/Jc3/Jc-intro-block-4-img-2.png"
                    alt="Prioritizing ESG Image"
                    class="tw-w-[76px] tw-h-[76px] tw-p-[11px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[13px] tw-items-start tw-flex-1"
                >
                    <span
                        class="tw-text-[16px] tw-font-bold tw-leading-[22px] tw-text-left"
                        >Prioritizing ESG</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-left"
                        >As such, SMEs who transition towards sustainable
                        practices can better mitigate risks, potentially improve
                        their competitiveness (e.g. by attracting
                        larger/multi-national companies who are increasingly
                        prioritizing ESG in their supply chains or expanding to
                        new/wider export markets) and achieve operational
                        efficiency (e.g. by lowering operational cost from
                        energy efficiency and adopting circular economy
                        models).</span
                    >
                </div>
            </div>
            <div
                class="tw-flex tw-flex-row tw-gap-[10px] tw-items-start tw-p-[30px] tw-bg-[#ECF0F0] tw-rounded-[10px] tw-h-full"
            >
                <img
                    src="assets/images/Jc3/Jc-intro-block-4-img-5.png"
                    alt="The JC3 SME Focus Group Image"
                    class="tw-w-[76px] tw-h-[76px] tw-p-[11px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[13px] tw-items-start tw-flex-1"
                >
                    <span
                        class="tw-text-[16px] tw-font-bold tw-leading-[22px] tw-text-left"
                        >The JC3 SME Focus Group</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-left"
                        >To encourage more SMEs to take the first steps along
                        the ESG journey, the JC3 SME Focus Group ("SFG") has
                        developed a ESG JumpStart Guide ("the Guide"), a simple
                        and practical reference guide for SMEs. It contains
                        suggested actions that SMEs could take to:
                        <ul
                            class="tw-list-disc tw-list-inside marker:tw-text-[#1A202C]"
                        >
                            <li>Build up basic ESG knowledge & capability</li>
                            <li>Identify and respond to key ESG</li>
                        </ul></span
                    >
                </div>
            </div>
        </div> -->

        <!-- Row 3 -->
        <!-- <div class="tw-grid tw-grid-cols-2 tw-gap-[20px] tw-items-stretch">
            <div
                class="tw-flex tw-flex-row tw-gap-[10px] tw-items-start tw-p-[30px] tw-bg-[#ECF0F0] tw-rounded-[10px] tw-h-full"
            >
                <img
                    src="assets/images/Jc3/Jc-intro-block-4-img-3.png"
                    alt="How SMEs can win in ESG Image"
                    class="tw-w-[76px] tw-h-[76px] tw-p-[3px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[13px] tw-items-start tw-flex-1"
                >
                    <span
                        class="tw-text-[16px] tw-font-bold tw-leading-[22px] tw-text-left"
                        >How SMEs can win in ESG</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-left"
                        >Ultimately, SMEs who are most adept at re-inventing
                        themselves, balancing long-term growth with
                        environmental & social responsibility can emerge as
                        winners in the new economy.</span
                    >
                </div>
            </div>
            <div
                class="tw-flex tw-flex-row tw-gap-[10px] tw-items-start tw-p-[30px] tw-bg-[#ECF0F0] tw-rounded-[10px] tw-h-full"
            >
                <img
                    src="assets/images/Jc3/Jc-intro-block-4-img-6.png"
                    alt="ESG Jumpstart Guide Image"
                    class="tw-w-[76px] tw-h-[76px] tw-p-[3px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[13px] tw-items-start tw-flex-1"
                >
                    <span
                        class="tw-text-[16px] tw-font-bold tw-leading-[22px] tw-text-left"
                        >ESG Jumpstart Guide</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-left"
                        >The Guide also acts as the starting point for the JC3
                        ESG Jumpstart portal for SMEs.</span
                    >
                </div>
            </div>
        </div> -->
    </div>
</div>

<!-- Mobile/Tablet Version -->
<div class="tw-block lg:tw-hidden tw-py-[50px] tw-px-[28px]">
    <div
        class="tw-flex tw-flex-col tw-gap-[18px] tw-items-left md:tw-items-center tw-mb-[30px]"
    >
        <span
            class="tw-text-[22px] tw-font-bold tw-text-left tw-leading-[28px] tw-text-[#024B3F]"
        >
            {{ gsData?.title }}
        </span>
        <span
            [innerHTML]="gsData?.description"
            class="tw-text-[14px] tw-font-normal tw-text-left md:tw-text-center tw-leading-[100%] tw-max-w-[623px] default-html"
        >
            T
        </span>
        <!-- <span
            class="tw-text-[14px] tw-font-normal tw-text-left md:tw-text-center tw-leading-[140%] tw-max-w-[623px]"
        >
            It contains suggested actions that SMEs could take to:
        </span> -->
    </div>

    <app-mobile-get-started
        [getStartedItems]="getStartedItems"
    ></app-mobile-get-started>
</div>
